import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { InsideSection } from '../components/sales/InsideSection';
import { PainSection } from '../components/sales/PainSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { BeforeAfterSection } from '../components/sales/BeforeAfterSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { OfferSection } from '../components/sales/OfferSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalSection } from '../components/sales/FinalSection';
import { SiteFooter } from '../components/sales/SiteFooter';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-183" data-mp="3qprnmsngzk0w">
      <header className="border-b border-brand-charcoal/10 bg-brand-paper" data-id="element-184" data-mp="3vntfo32vitoi">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-185" data-mp="3akrthls6620o">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-186" data-mp="35rypx18fszq6">
            Lash &amp; Brow Instructor Ready™ · by Prof. Kyra
          </p>
        </div>
      </header>

      <main data-id="element-187" data-mp="2vw58p4jrwi22">
        <HeroSection data-id="element-188" data-mp="2vwn9mehdrkgb" />
        <InsideSection data-id="element-189" data-mp="2vszj7o78fe5t" />
        <PainSection data-id="element-190" data-mp="3tj44ze6jznzf" />
        <SolutionSection data-id="element-191" data-mp="3thj8hj0ohuyx" />
        <VolumesSection data-id="element-192" data-mp="3tht0td974e7s" />
        <BonusesSection data-id="element-193" data-mp="3ojhsx82gods7" />
        <BeforeAfterSection data-id="element-194" data-mp="3oj81rh5ok0kx" />
        <AudienceSection data-id="element-195" data-mp="3ok10buuhjjrz" />
        <OfferSection data-id="element-196" data-mp="3ohewo6aptof1" />
        <FaqSection data-id="element-197" data-mp="3jk4wpwpp9ucy" />
        <FinalSection data-id="element-198" data-mp="3jjn214ioro75" />
      </main>

      <SiteFooter data-id="element-199" data-mp="3jilg2504than" />
    </div>;
}